import React from "react";

const AboutStyleThree = () => {
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      name: e.target.name.value,
      email: e.target.email.value,
      passengers: e.target.passengers.value,
      pickup: e.target.pickup.value,
      dropoff: e.target.dropoff.value,
      date: e.target.date.value,
      time: e.target.time.value,
    };

    const message = `🚖 New Cab Booking Request

Name: ${formData.name}
Email: ${formData.email}
Passengers: ${formData.passengers}
Pickup: ${formData.pickup}
Drop Off: ${formData.dropoff}
Date: ${formData.date}
Time: ${formData.time}`;

    const whatsappNumber = "919594849797";

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );

    e.target.reset();
  };

  return (
    <section className="about-style-three clearfix">
      {/* LEFT CONTENT */}
      <div className="left-block">
        <div className="content-block">
          <div className="image-block">
            <img src="images/resources/book-1-1.jpg" alt="Om Sai Cabs" />
          </div>

          <div className="block-title">
            <div className="dot-line"></div>
            <p>Trusted Cab Service in Your City</p>
            <h2>
              Welcome to <br />
              Om Sai Cabs
            </h2>
          </div>

          <p>
            Om Sai Cab Service is dedicated to providing safe, reliable, and
            comfortable transportation solutions for all your travel needs.
            Whether you need a quick local ride, an airport transfer, or a
            long-distance outstation journey, we ensure a smooth and
            hassle-free travel experience at affordable prices. Our
            professional drivers, well-maintained vehicles, and 24/7 customer
            support make every trip convenient, secure, and enjoyable.
          </p>
        </div>
      </div>

      {/* RIGHT CONTENT */}
      <div className="right-block">
        <div className="right-upper-block">
          <div className="content-block">
            <div className="block-title">
              <div className="dot-line"></div>
              <p className="light-2">Need a Taxi?</p>
              <h2 className="light">
                Book Your <br />
                Ride Now
              </h2>
            </div>

            {/* FORM */}
            <form className="booking-form-one" onSubmit={handleSubmit}>
              <div className="row">

                {/* Name */}
                <div className="col-lg-6 py-2">
                  <label className="text-white">Your Name</label>
                  <input
                    type="text"
                    name="name"
                    required
                  />
                </div>

                {/* Email */}
                <div className="col-lg-6 py-2">
                  <label className="text-white">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    required
                  />
                </div>

                {/* Passengers */}
                <div className="col-lg-12 py-2">
                  <label className="text-white">Passengers</label>
                  <input
                    type="text"
                    name="passengers"
                    required
                  />
                </div>

                {/* Pickup */}
                <div className="col-lg-12 py-2">
                  <label className="text-white">Pick Up Address</label>
                  <input
                    type="text"
                    name="pickup"
                    required
                  />
                </div>

                {/* Dropoff */}
                <div className="col-lg-12 py-2">
                  <label className="text-white">Drop Off Address</label>
                  <input
                    type="text"
                    name="dropoff"
                    required
                  />
                </div>

                {/* Date */}
                <div className="col-lg-6 py-2">
                  <label className="text-white">Select Date</label>
                  <input
                    type="date"
                    name="date"
                    min={new Date().toISOString().split("T")[0]}
                    required
                  />
                </div>

                {/* Time */}
                <div className="col-lg-6 py-2">
                  <label className="text-white">Select Time</label>
                  <input
                    type="time"
                    name="time"
                    required
                  />
                </div>

                {/* Button */}
                <div className="col-lg-12 py-3">
                  <button type="submit">Book Now</button>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStyleThree;